/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import Slider from "react-slick";
import { Trans } from "react-i18next";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { getIntroVideos, showModal } from "actions";
import {
  VideoModalBody,
  VideoModalFooter,
} from "components/widgets/introVideos/VideoModal";

import Video from "components/widgets/introVideos/Video";
import * as Alerts from "components/elements/alerts";
import { Link } from "react-router-dom";
import "components/widgets/introVideos/Videos.css";

class Videos extends Component {
  state = {
    videoListFetched: false,
    error: null,
  };

  settings = {
    className: "videolar slick-dotted",
    dots: false,
    draggable: true,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
  }

  fetchData = () => {
    this.props.getIntroVideos(this.onBegin, this.onSuccess, this.onError);
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    this.setState({ error: err.message });
    this.props.onProcessEnd();
  };

  onSuccess = () => {
    this.props.onProcessEnd();
    this.setState({
      videoListFetched: true,
    });
  };

  selectVideo = (idx) => {
    if (idx + 1 > this.props.videos.length) return null;
    let v = this.props.videos[idx];
    this.props.showModal({
      modalType: "video",
      modalTitle: v.subject,
      modalContent: (
        <VideoModalBody
          frameCode={v.frameCode}
          subject={v.subject}
          detail={v.detail}
        />
      ),
      modalFooter: (
        <VideoModalFooter idx={idx} selectAnnouncement={this.selectVideo} />
      ),
    });
  };

  renderError = () => {
    if (this.state.error) {
      return (
        <div style={{ backgroundColor: "white" }}>
          <div style={{ width: "80%", margin: "auto" }}>
            {Alerts.RedAlert({ content: this.state.error })}
          </div>
        </div>
      );
    } else return null;
  };

  renderIndividualVideos = () => {
    if (this.state.videoListFetched) {
      return this.props.videos.map((video, idx) => {
        return (
          <Video
            key={video.id}
            videoId={video.id}
            videoThumbnail={video.thumbnailURL}
            videoDescription={video.detail}
            videoTitle={video.subject}
            onSelect={() => this.selectVideo(idx)}
          />
        );
      });
    } else {
      return null;
    }
  };

  renderVideos = () => {
    if (!this.state.videoListFetched) {
      return (
        <>
          <div>{this.props.spinner}</div>
          <div>
            <br />
          </div>
        </>
      );
    }
    if (this.props.showAllEnabled)
      return (
        <Slider {...this.settings}>{this.renderIndividualVideos()}</Slider>
      );

    return (
      <div
      // style={{
      //   backgroundColor: "#FFFFFF",
      // }}
      >
        <div>
          <br />
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(200px,1fr))",
          }}
        >
          {this.renderIndividualVideos()}
        </div>
      </div>
    );
  };

  render() {
    return (
      <>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          {this.props.showAllEnabled ? (
            <div className="duyuruButton videoAreaTop">
              <div className="duyuruTextArea">
                <div className="duyuruInfo">
                  <div className="duyuruAnaBaslik">
                    <Trans desc="Tanıtım Videoları">10023</Trans>
                  </div>
                </div>
              </div>
              <Link to="/introduction-videos">
                <div className="arrow">
                  <div className="tumDuyurular">
                    <Trans>10012</Trans>
                  </div>
                  <span className="iconmford fo-icon-keyboard-arrow-right"></span>
                </div>
              </Link>
            </div>
          ) : null}
          {this.renderError()}
          {this.renderVideos()}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    videos: state.introVideos.data,
    modal: state.modal,
    application: state.application,
  };
};

export default connect(mapStateToProps, { getIntroVideos, showModal })(
  containsLongRunningProcess(Videos)
);
